var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5566 4.32867H8.91539C8.77594 4.32867 8.64332 4.39567 8.56129 4.51051L6.41207 7.49098L5.43863 6.1402C5.3566 6.02672 5.22535 5.95836 5.08453 5.95836H4.44332C4.35445 5.95836 4.3025 6.05953 4.35445 6.13199L6.05797 8.49449C6.09821 8.55066 6.15126 8.59643 6.21272 8.628C6.27419 8.65958 6.34229 8.67605 6.41139 8.67605C6.48048 8.67605 6.54859 8.65958 6.61005 8.628C6.67151 8.59643 6.72456 8.55066 6.7648 8.49449L9.6441 4.50231C9.69742 4.42985 9.64547 4.32867 9.5566 4.32867Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.37793C3.61758 0.37793 0.875 3.12051 0.875 6.50293C0.875 9.88535 3.61758 12.6279 7 12.6279C10.3824 12.6279 13.125 9.88535 13.125 6.50293C13.125 3.12051 10.3824 0.37793 7 0.37793ZM7 11.5889C4.1918 11.5889 1.91406 9.31113 1.91406 6.50293C1.91406 3.69473 4.1918 1.41699 7 1.41699C9.8082 1.41699 12.0859 3.69473 12.0859 6.50293C12.0859 9.31113 9.8082 11.5889 7 11.5889Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.7f1a80c2c06eeb97cd491c13be36e9c7.svg";
export { ForwardRef as ReactComponent };